/**
 * Helpers puros de la pantalla pública de turnos: clasificación de entradas,
 * alertas de preparación y textos de voz
 */
import { getMostradorLabel, ORDER_STATE } from "../../../config/constants";
import { ENTRADA_ESTADO, PANTALLA_LLAMADOS_MAX } from "../constants";

const ESTADOS_EN_ALERTA = [ORDER_STATE.SIN_PREPARAR, ORDER_STATE.EN_PREPARACION];

// 'modificado' es ISO: se compara como texto; null/undefined pasan a ''
const porModificadoDesc = (a, b) => String(b.modificado ?? "").localeCompare(String(a.modificado ?? ""));

const porPosicionAsc = (a, b) => a.posicion - b.posicion;

/**
 * Divide las entradas de una cola en { actual, llamados, esperando }.
 * actual: la 'llamado' con modificado más reciente. llamados: hasta
 * PANTALLA_LLAMADOS_MAX 'llamado|finalizado' distintas de la actual, más recientes
 * primero. esperando: 'esperando' por posicion. DECISION: tolera modificado nulo y
 * entradas no-array (el legacy reventaba con b.modificado.localeCompare).
 */
export const clasificarEntradas = (entradas) => {
    const lista = Array.isArray(entradas) ? entradas : [];
    const actual = lista
        .filter((e) => e.estado === ENTRADA_ESTADO.LLAMADO)
        .sort(porModificadoDesc)[0] ?? null;
    const llamados = lista
        .filter((e) =>
            (e.estado === ENTRADA_ESTADO.LLAMADO || e.estado === ENTRADA_ESTADO.FINALIZADO) &&
            e.id !== actual?.id)
        .sort(porModificadoDesc)
        .slice(0, PANTALLA_LLAMADOS_MAX);
    const esperando = lista
        .filter((e) => e.estado === ENTRADA_ESTADO.ESPERANDO)
        .sort(porPosicionAsc);
    return { actual, llamados, esperando };
};

/**
 * Indica si el estado de un pedido debe resaltarse (cualquiera distinto de FINALIZADO,
 * el único estado que cierra el documento)
 */
export const detalleEsAlerta = (estado) => estado !== ORDER_STATE.FINALIZADO;

/**
 * Indica si algún pedido del turno está sin preparar o en preparación
 */
export const hayAlertaPreparacion = (detalles) =>
    Array.isArray(detalles) && detalles.some((d) => ESTADOS_EN_ALERTA.includes(d?.estado));

/**
 * Texto de voz al llamar un turno: "Turno N, <mostrador>" (cadena vacía si no hay turno)
 */
export const textoLlamada = (turno) => {
    // Sin turno no hay nada que locutar: cadena vacía en vez de "Turno undefined"
    if (!turno) return "";
    const mostrador = turno.mostrador ? getMostradorLabel(turno.mostrador) : "";
    return mostrador ? `Turno ${turno.numero}, ${mostrador}` : `Turno ${turno.numero}`;
};

/**
 * Texto de voz cuando llega un turno con un pedido sin preparar
 */
export const textoAlertaPedido = (numero) => `Atención, pedido ${numero} esperando y sin preparar`;
